import React from 'react';
import type { QuotaCellProgress } from '../../types';
import { Badge } from '../../ui';

/**
 * Live fill of one quota row, from respondent sessions (GET /project/{id}/statistics, `cells[]`, matched to the row by
 * `index`): completes against wanted, people still in the survey, and whether the cell is full or still open.
 * The server decides `full`; nothing is worked out here beyond the wording.
 */
export function CellFill({ cell }: { cell: QuotaCellProgress | undefined }) {
  if (!cell) return <span className="text-muted" aria-label="No fill figures for this row">—</span>;
  const inSurvey = cell.inSurvey > 0 ? ` +${cell.inSurvey} in survey` : '';
  return (
    <span className="inline-flex flex-wrap items-center justify-end gap-1.5" title={`${cell.completes} of ${cell.wanted} complete, ${cell.inSurvey} in survey, ${cell.remaining} places left`}>
      <span className="tabular-nums text-ink">{cell.completes}/{cell.wanted}<span className="text-xs text-muted">{inSurvey}</span></span>
      <Badge tone={cell.full ? 'danger' : 'ok'}>{cell.full ? 'Full' : 'Open'}</Badge>
    </span>
  );
}
